
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/migracja-numeru/typ-oferty-mobilnej",
      function () {
        return require("private-next-pages/migracja-numeru/typ-oferty-mobilnej.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/migracja-numeru/typ-oferty-mobilnej"])
      });
    }
  